import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './controller_create.routes';

import CompanyService from '../../../../components/api/company/company.service';
import SaConfigService from '../../../../components/api/sa_config/sa_config.service';
import DistStockService from '../../../../components/api/dist_stock/dist_stock.service';
import ControllerConfigService from '../../../../components/api/controller_config/controller_config.service';
import ZipSearchLogic from '../../../../components/logic/zip-search/zip-search.logic';

class ControllerDeviceCreateController {
  /*@ngInject*/
  constructor($state, $stateParams, $scope, $timeout, $mdDialog, CompanyService, SaConfigService, DistStockService, ControllerConfigService, ZipSearchLogic) {
    this.CompanyService = CompanyService;
    this.ControllerConfigService = ControllerConfigService;
    this.DistStockService = DistStockService;
    this.SaConfigService = SaConfigService;
    this.ZipSearchLogic = ZipSearchLogic;
    this.company_id = $stateParams.company_id;
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.deviceConfig = {
      mode: 'reading_only',
      wlan_enabled: false,
      company_id: $stateParams.company_id,
      carrier_port: 'mdm0',
      remoteio_name: 'panasonic-uenu2d4r12'
    };

    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '作成しますか?',
        ok: '作成する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '作成しました',
        content: '端末一覧 画面に移動します',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、サポートにお問い合わせください。',
        ok: 'OK'
      })
    };

    $scope.$watch('$ctrl.deviceConfig.zip_code', current => {
      if (current) {
        this.ZipSearchLogic.get(current).then(address => {
          $timeout(() => {
            this.deviceConfig.location = address.prefecture_name + address.city_name + address.town_name;
          });
        });
      }
    });
  }

  $onInit() {
    this.SaConfigService.oem_api.index({company_id: this.company_id}, response => {
      this.readingDevices = response;
    });
    this.CompanyService.show({id: this.company_id}, response => {
      this.company = response;
    }, err => {
      if (err.status === 404 || err.status === 403) {
        this.$state.go('oem_main.oem_home');
      }
    });
    this.DistStockService.oem_api.index({service_type: 'tss'}, response => {
      this.deviceStocks = response.dist_stocks;
    });
  }

  showConfirm(deviceConfig, ev) {
    this.$mdDialog.show(this.dialog.confirm.targetEvent(ev))
      .then(() => {
        this.ControllerConfigService.oem_api.create(
          deviceConfig,
          (okResponse) => { this.$mdDialog.show(this.dialog.success).finally(() => this.$state.go('oem_main.device_index', {company_id: this.company_id})); },
          (errResponse) => { this.$mdDialog.show(this.dialog.error.content(errResponse.data.message)); }
        );
      });
  }
}

export default angular.module('leptonApp.controllerDeviceCreate', [uiRouter, CompanyService, SaConfigService, DistStockService, ControllerConfigService, ZipSearchLogic])
  .config(routing)
  .component('controllerDeviceCreate', {
    template: require('./controller_create.html'),
    controller: ControllerDeviceCreateController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/controller_create/controller_create.component.js